
import Tab from "../Tab.vue";
import Section from "../Section.vue";
import { mapState } from "vuex";
export default {
  components: {
    Tab,
    Section,
  },
  props: {
    setSearchValue: {
      type: Function,
      default: () => {},
    },
    setComponent: {
      type: Function,
      default: () => {},
    },
    setMajorName: {
      type: Function,
      default: () => {},
    },
    setGroupMajorName: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState("Major", [
      "listGroupMajor",
      "majorLoading",
      "listRawGroupMajor",
    ]),
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      baseIconURL: this.$config.BASE_URL_RESOURCE,
      searchText: "",
    };
  },
  mounted() {
    this.$store.dispatch("Major/getListGroupMajor");
  },
  methods: {
    onKeyPress(e) {
      if (e.key === "Enter") {
        this.setSearchValue(this.searchText);
        this.setComponent("MajorResult");
      }
    },
  },
};
